"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swiperOptions = {
    direction: 'horizontal',
    loop: true,
    grabCursor: true,
    centeredSlides: true,
    lazy: {
        loadPrevNext: true
    },
    navigation: {
        nextEl: '.carousel-side-next',
        prevEl: '.carousel-side-prev'
    }
};
